(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GraphicArchiveItemIbqDialogController', GraphicArchiveItemIbqDialogController);

    GraphicArchiveItemIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GraphicArchiveItem', 'MusicalPiece', 'Publisher', 'Country', 'Person'];

    function GraphicArchiveItemIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GraphicArchiveItem, MusicalPiece, Publisher, Country, Person) {
        var vm = this;

        vm.graphicArchiveItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.publishers = Publisher.query();
        vm.countries = Country.query();
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.graphicArchiveItem.id !== null) {
                GraphicArchiveItem.update(vm.graphicArchiveItem, onSaveSuccess, onSaveError);
            } else {
                GraphicArchiveItem.save(vm.graphicArchiveItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:graphicArchiveItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.publicationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
